export enum Environment {
    LOCAL = "LOCAL",
    DEV = "DEV",
    TEST = "TEST",
    UAT = "UAT",
    PROD = "PROD"
}

/** Synchronous env check — returns LOCAL as default.
 *  For accurate runtime env, fetch /api/config instead. */
export const getCurrentEnv = (): Environment => Environment.LOCAL;
export const isProdEnv = (): boolean => getCurrentEnv() === Environment.PROD;
export const isDevEnv = (): boolean => getCurrentEnv() === Environment.DEV;
